import { Image } from '../Image'
import { Container } from './styles'
// eslint-disable-next-line import/no-cycle

export const Loader = () => (
  <Container data-testid="loader">
    <Image name="logo" type="gif" />
  </Container>
)
